export class Provoked {
  private static _values: Provoked[] = [];
  private static _lookup: Map<number, Provoked> = new Map();

  static fromId(id: number) {
    const instance = Provoked._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Provoked.id: ' + id);
    }
    return instance;
  }

  static values(): Provoked[] {
    return [...Provoked._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Provoked._values.push(this);
    Provoked._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Provoked: ' + this.id + ", label='" + this.label + "'>";
  }
}
